/* Pretty in Pink: maatkiezer zoals Loavies (27-09-2026). Geladen vanuit snippets/pip-maatkiezer.liquid (alleen de productpagina).
   - Klik op het veld "Kies je maat": mobiel een lade onderin, desktop een lijst onder het veld. Alle maten in één keer in beeld.
   - Een maat kiezen zet de (onzichtbare) maatknop van Dawn aan, zodat Dawn prijs, voorraad, URL en apps bijwerkt zoals altijd.
   - Klik op een uitverkochte maat: de popup met e-mailveld opent en de maat wordt NIET gekozen (de koopknop blijft zoals hij was).
     De aanmelding geldt voor precies die maat in die kleur. Aanmelden via de openbare Klaviyo-aanroep voor "terug op voorraad",
     dezelfde aanroep als de Klaviyo-popup zelf (de code van de Klaviyo-app blijft onaangeroerd). Geen vinkje nodig.
   - Zijn alle maten uitverkocht, dan staat onder het veld een zwarte knop "Houd me op de hoogte" in plaats van de koopknop;
     die opent de lijst om een maat te kiezen.
   - snippets/pip-maatkeuze.liquid roept window.pipMk.error(sectie) aan als iemand op de koopknop drukt zonder maat:
     dan staat onder het veld het blok 'Selecteer een maat.' (fase 2, groep 10; eerst opende de lijst). Het blok verdwijnt
     zodra de lijst opent of er een maat is gekozen.
   - Groep 11 (27-09): kiezen werkt nu ook in Safari en Firefox op de Mac (zie de focusin-regel onderaan).
   - Groep 13 (28-09): dezelfde lade/popup opent ook vanaf een productkaart. Het envelopje van een product dat niet op voorraad
     is (knop met data-pip-bis-open, snippets/pip-card-bis-btn.liquid) roept openCard aan: eerst de lijst met maten, daarna het
     e-mailveld. Zonder maten meteen het e-mailveld. De teksten komen dan uit <script id="PipBisTexts"> (snippets/pip-card-bis.liquid).
     De opmaak staat in assets/pip-mk-layer.css.
   - Groep 16 (29-09): de sticky koopknop (assets/pip-sticky-atc.js) opent de lijst via window.pipMk.open: mobiel de lade,
     desktop een lijst die boven het maatveld in de balk uitrolt (opts.drop; 15:30 op verzoek, eerst een popup in het midden).
     Na een keuze stuurt dit script het event 'pip:mk-chosen', bij sluiten 'pip:mk-closed'.
   - Groep 17 (30-09): de Pasvormtip (belangrijke mededeling, metaveld custom.size_fit_note) staat alleen nog bovenaan de lijst
     met maten, niet meer op de productpagina zelf (zie snippets/size-fit-note.liquid). Groep 17b (30-09, 13:22, verzoek): weer
     als gewone tekstregel zoals eerst, niet als kader; de opmaak (iets groter, donker) staat in pip-mk-layer.css.
   Teksten en kleuren: Thema-instellingen > PIP productpagina > Maatkiezer. */
(function () {
  'use strict';
  if (window.pipMk) return;

  var MQ = window.matchMedia('(max-width: 749px)');
  var REVISION = '2026-07-15'; /* Klaviyo API-versie; geldig tot juli 2028 (fase 2, groep 7: bijgewerkt van 2025-04-15) */
  var ICON_MAIL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="5.5" width="18" height="13" rx="1.5"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_WA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.8a9.2 9.2 0 0 0-7.9 13.9L3 21l4.4-1.1A9.2 9.2 0 1 0 12 2.8z"/><path d="M9 7.8c.2-.4.4-.4.7-.4h.5c.2 0 .4 0 .5.4l.7 1.7c.1.2 0 .4-.1.5l-.5.6c-.1.2-.2.3 0 .5.5.8 1.1 1.4 1.9 1.9.2.1.4.1.5 0l.6-.7c.2-.2.3-.2.5-.1l1.7.8c.2.1.3.2.3.4 0 .3 0 .9-.4 1.3-.5.5-1.1.7-1.8.6-1.1-.1-2.2-.6-3.5-1.7-1.4-1.3-2.1-2.5-2.4-3.5-.2-.9.1-1.7.3-2.3z"/></svg>';

  var states = {};
  var layer = null;   /* één lade/popup voor de hele pagina, los in de body (niet binnen een vak met transform) */
  var layerSt = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(aantal|maat|product)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function rootFor(sid) {
    var all = document.querySelectorAll('[data-pip-mk]');
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-section') === sid) return all[i];
    return null;
  }
  /* bij een productkaart (groep 13) is de knop die de popup opende het 'veld': daar gaat de focus naar terug */
  function trigger(st) { return st.opener || st.root.querySelector('.pip-mk__trigger'); }
  /* aria-expanded alleen op een veld dat een lijst opent (niet op de koopknop van de sticky balk) */
  function expanded(st, on) {
    var t = trigger(st);
    if (t && t.hasAttribute('aria-haspopup')) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  /* groep 16: klaar met de lijst vanaf de sticky koopknop; daarna geldt het gewone veld weer als veld */
  function endSticky(st) {
    if (!st || !st.viaSticky) return;
    st.viaSticky = false; st.opener = null; st.modal = false; st.hint = ''; st.dropTo = null;
    try { document.dispatchEvent(new CustomEvent('pip:mk-closed', { detail: { sid: st.sid } })); } catch (e) {}
  }

  function init(root) {
    if (!root) return null;
    if (root.__pipMk) return root.__pipMk;
    var el = root.querySelector('[data-pip-mk-data]');
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!data || !data.variants || data.idx == null) return null;
    var st = {
      root: root, d: data, t: data.t || {},
      sid: root.getAttribute('data-section'), formId: root.getAttribute('data-form'),
      chosen: null, error: false, open: false, bis: null
    };
    /* komt iemand binnen met ?variant= (advertentie, mail), dan is die maat al gekozen, net als in pip-maatkeuze */
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === m[1]) { st.chosen = data.variants[i].o[data.idx]; break; }
      }
    }
    root.__pipMk = st;
    states[st.sid] = st;
    renderTrigger(st);
    syncButtons(st);
    return st;
  }

  /* ---------- Dawn maatkiezer (onzichtbaar) ---------- */

  function picker(st) { return document.getElementById('variant-selects-' + st.sid); }
  function sizeBox(st) {
    var vs = picker(st);
    return vs ? vs.querySelector('.pip-size-opt') : null;
  }
  /* gekozen waarden van de andere opties (bijvoorbeeld kleur), in optie-volgorde; null = niet gekozen */
  function others(st) {
    var vs = picker(st), out = [];
    if (!vs) return out;
    var i = 0;
    for (var n = 0; n < vs.children.length; n++) {
      var b = vs.children[n];
      if (!b.matches || !b.matches('fieldset, .product-form__input--dropdown')) continue;
      if (b.classList.contains('pip-size-opt')) { out[i] = null; }
      else {
        var c = b.querySelector('input:checked'), s = b.querySelector('select');
        out[i] = c ? c.value : (s ? s.value : null);
      }
      i++;
    }
    return out;
  }
  /* beschikbaarheid en voorraad van een maat, passend bij de andere gekozen opties */
  function info(st, size, oth) {
    var d = st.d, list = [], a = false;
    d.variants.forEach(function (v) {
      if (v.o[d.idx] !== size) return;
      for (var j = 0; j < v.o.length; j++) {
        if (j !== d.idx && oth[j] != null && v.o[j] !== oth[j]) return;
      }
      list.push(v);
      if (v.a) a = true;
    });
    var one = null;
    for (var k = 0; k < list.length; k++) if (list[k].a) { one = list[k]; break; }
    if (!one) one = list[0] || null;
    return { a: a, v: one, q: list.length === 1 ? list[0].q : 999 };
  }
  function setDawn(st, size) {
    var box = sizeBox(st);
    if (!box) return;
    var sel = box.querySelector('select');
    if (sel) {
      sel.value = size;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var inputs = box.querySelectorAll('input[type="radio"]');
    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].value === size) {
        inputs[k].checked = true;
        inputs[k].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  /* ---------- weergave ---------- */

  function renderTrigger(st) {
    var val = st.root.querySelector('[data-pip-mk-value]');
    if (val) {
      val.textContent = st.chosen != null ? st.chosen : (st.t.placeholder || 'Kies je maat');
      val.classList.toggle('is-placeholder', st.chosen == null);
    }
    st.root.classList.toggle('is-error', !!st.error);
    var err = st.root.querySelector('.pip-mk__error');
    if (st.error) {
      if (!err) {
        err = document.createElement('p');
        err.className = 'pip-mk__error';
        err.setAttribute('role', 'alert');
        st.root.appendChild(err);
      }
      err.textContent = st.t.error || 'Selecteer een maat.';
    } else if (err) {
      err.remove();
    }
  }

  function optsHTML(st) {
    var oth = others(st), t = st.t, h = '';
    st.d.sizes.forEach(function (size) {
      var i = info(st, size, oth);
      if (!i.v) return; /* deze maat bestaat niet in deze combinatie */
      var right = '';
      if (!i.a) right = '<span class="pip-mk__soon">' + esc(t.soldout) + ICON_MAIL + '</span>';
      else if (i.q > 0 && i.q <= st.d.leftMax) right = '<span class="pip-mk__left">' + esc(fill(t.left, { aantal: i.q })) + '</span>';
      h += '<button type="button" class="pip-mk__opt' + (i.a ? '' : ' is-out') + '" data-pip-mk-size="' + esc(size) + '"' +
        (st.chosen === size ? ' aria-current="true"' : '') + '>' +
        '<span class="pip-mk__size">' + esc(size) + '</span>' + right + '</button>';
    });
    return h;
  }
  function listHTML(st) {
    return (st.hint ? '<p class="pip-mk__hint">' + esc(st.hint) + '</p>' : '') + (st.d.note ? '<p class="pip-mk__note">' + esc(st.d.note) + '</p>' : '') +
      '<div class="pip-mk__opts">' + optsHTML(st) + '</div>';
  }

  function soldOutNow(st) {
    var oth = others(st);
    if (st.chosen != null) return !info(st, st.chosen, oth).a;
    var out = true;
    st.d.sizes.forEach(function (s) { var i = info(st, s, oth); if (i.v && i.a) out = false; });
    return out;
  }

  /* zwarte knop "Houd me op de hoogte" naast/in plaats van de koopknop */
  function syncButtons(st) {
    var f = document.getElementById(st.formId);
    var pf = f && f.closest('product-form');
    if (!pf) return;
    pf.classList.add('pip-mk-form');
    var box = pf.querySelector('.product-form__buttons');
    if (!box) return;
    var btn = box.querySelector('.pip-mk-notify');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pip-mk-notify';
      btn.setAttribute('data-pip-mk-notify', st.sid);
      var sub = box.querySelector('.product-form__submit');
      if (sub && sub.nextSibling) box.insertBefore(btn, sub.nextSibling);
      else box.appendChild(btn);
    }
    btn.textContent = st.t.bisBtn || 'Houd me op de hoogte';
    pf.classList.toggle('pip-mk-soldout', soldOutNow(st));
  }

  /* ---------- openen en sluiten ---------- */

  function openList(st) {
    closeAllLists(st);
    if (st.error) { st.error = false; renderTrigger(st); }
    st.open = true;
    st.root.classList.toggle('is-open', !st.dropTo);
    expanded(st, true);
    if (MQ.matches || st.modal) { /* groep 16: modal = popup op desktop (alleen nog als de balk geen maatveld heeft) */
      showLayer(st, 'list');
      return;
    }
    /* groep 16: vanaf de sticky koopknop rolt de lijst uit boven het maatveld in de balk (st.dropTo) */
    var own = st.root.querySelector('.pip-mk__drop');
    var drop = st.dropTo || own;
    if (st.dropTo) {
      if (own && !own.hidden) { own.hidden = true; own.innerHTML = ''; }
      st.dropTo.setAttribute('data-pip-mk-for', st.sid);
    }
    drop.innerHTML = listHTML(st);
    drop.hidden = false;
    var first = drop.querySelector('.pip-mk__opt[aria-current="true"]') || drop.querySelector('.pip-mk__opt');
    if (first) first.focus({ preventScroll: true });
  }

  /* keep = true: de lijst van de sticky knop gaat dicht, maar er opent meteen een popup (maat niet op voorraad) */
  function markClosed(st, keep) {
    st.open = false;
    if (st.card) return;
    st.root.classList.remove('is-open');
    expanded(st, false);
    var drop = st.root.querySelector('.pip-mk__drop');
    if (drop && !drop.hidden) { drop.hidden = true; drop.innerHTML = ''; }
    if (st.dropTo) {
      st.dropTo.hidden = true;
      st.dropTo.innerHTML = '';
      st.dropTo = null;
      if (!keep) endSticky(st);
    }
  }

  function closeList(st, focusBack) {
    if (!st || !st.open) return;
    var inLayer = layer && layerSt === st && !layer.hidden && layer.getAttribute('data-mode') === 'list';
    var back = trigger(st);
    markClosed(st);
    if (inLayer) hideLayer();
    else if (focusBack && back) back.focus();
  }

  function closeAllLists(except) {
    Object.keys(states).forEach(function (k) {
      if (states[k] !== except && states[k].open) closeList(states[k], false);
    });
  }

  function buildLayer() {
    layer = document.createElement('div');
    layer.className = 'pip-mk-layer';
    layer.hidden = true;
    layer.innerHTML =
      '<div class="pip-mk-layer__overlay" data-pip-mk-close></div>' +
      '<div class="pip-mk-panel" role="dialog" aria-modal="true" aria-labelledby="PipMkPanelTitle">' +
        '<div class="pip-mk-panel__head">' +
          '<h2 class="pip-mk-panel__title" id="PipMkPanelTitle"></h2>' +
          '<button type="button" class="pip-mk-panel__close" data-pip-mk-close>' + ICON_X + '</button>' +
        '</div>' +
        '<div class="pip-mk-panel__body"></div>' +
      '</div>';
    document.body.appendChild(layer);
  }

  /* product zonder maten (groep 13, vanaf een productkaart): tekst zonder [maat] */
  function noSize(st) { return !st.bis || !st.bis.size; }
  function bisHTML(st) {
    var t = st.t, map = { maat: st.bis.size, product: st.d.product }, wa = '';
    var one = noSize(st);
    var msg = one ? String(t.waMsg || '').replace(/\s*in maat \[maat\]/, '') : t.waMsg;
    if (t.wa && t.waUrl) {
      var url = t.waUrl + (t.waUrl.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(fill(msg, map));
      wa = '<a class="pip-mk-bis__wa" href="' + esc(url) + '" target="_blank" rel="noopener">' + ICON_WA + '<span>' + esc(t.waText) + '</span></a>';
    }
    return '<p class="pip-mk__text">' + esc(fill(one ? (t.bisTextOne || t.bisText) : t.bisText, map)) + '</p>' +
      '<form class="pip-mk-bis" novalidate>' +
        '<label class="pip-mk-bis__label" for="PipMkEmail">' + esc(t.emailLabel || 'E-mail') + '</label>' +
        '<input class="pip-mk-bis__input" id="PipMkEmail" name="email" type="email" autocomplete="email" inputmode="email" required aria-describedby="PipMkEmailErr">' +
        '<p class="pip-mk-bis__err" id="PipMkEmailErr" hidden></p>' +
        wa +
        '<button type="submit" class="pip-mk-bis__btn">' + esc(t.bisBtn) + '</button>' +
        '<p class="pip-mk-bis__fail" role="alert" hidden></p>' +
      '</form>';
  }

  /* knop in de popup krijgt dezelfde kleuren en letter als de koopknop van dit product (27-09-2026) */
  function atcLook(st) {
    var f = document.getElementById(st.formId);
    var pf = f && f.closest('product-form');
    var sub = pf && pf.querySelector('.product-form__submit');
    if (!sub || !layer) return;
    var cs = window.getComputedStyle(sub);
    var bg = cs.backgroundColor;
    if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') layer.style.setProperty('--pip-mk-atc-bg', bg);
    if (cs.color) layer.style.setProperty('--pip-mk-atc-text', cs.color);
    if (cs.fontSize) layer.style.setProperty('--pip-mk-atc-fs', cs.fontSize);
    if (cs.fontWeight) layer.style.setProperty('--pip-mk-atc-fw', cs.fontWeight);
    if (cs.letterSpacing && cs.letterSpacing !== 'normal') layer.style.setProperty('--pip-mk-atc-ls', cs.letterSpacing);
  }

  function showLayer(st, mode) {
    if (!layer) buildLayer();
    if (mode !== 'list') atcLook(st);
    var wasOpen = !layer.hidden && layer.classList.contains('is-in');
    layerSt = st;
    layer.setAttribute('data-mode', mode);
    /* vanaf een productkaart is ook de lijst op desktop een popup in het midden (er is geen veld om onder uit te klappen) */
    layer.classList.toggle('pip-mk-layer--modal', mode !== 'list' || !!st.card || (!!st.modal && !MQ.matches));
    var panel = layer.querySelector('.pip-mk-panel');
    var title = layer.querySelector('.pip-mk-panel__title');
    var body = layer.querySelector('.pip-mk-panel__body');
    var close = layer.querySelector('.pip-mk-panel__close');
    close.setAttribute('aria-label', st.t.close || 'Sluiten');
    var first;
    if (mode === 'list') {
      title.textContent = st.t.placeholder || 'Kies je maat';
      body.innerHTML = listHTML(st);
      /* lade (mobiel): focus op de gekozen maat, anders op Sluiten, zodat er geen focusrand om de eerste maat staat */
      first = body.querySelector('.pip-mk__opt[aria-current="true"]') || close;
    } else {
      title.textContent = st.t.bisTitle || '';
      body.innerHTML = bisHTML(st);
      /* mobiel niet meteen het toetsenbord openen: focus op Sluiten; desktop direct in het e-mailveld */
      first = MQ.matches ? close : body.querySelector('input');
    }
    if (!wasOpen) {
      layer.hidden = false;
      document.documentElement.classList.add('pip-mk-lock');
      void layer.offsetWidth;
      layer.classList.add('is-in');
    }
    panel.scrollTop = 0;
    if (window.pipFocus) window.pipFocus.on(panel, first, trigger(st));
    else if (first) first.focus();
  }

  function hideLayer() {
    if (!layer || layer.hidden) return;
    var st = layerSt;
    if (st && layer.getAttribute('data-mode') === 'list') markClosed(st);
    layer.classList.remove('is-in');
    document.documentElement.classList.remove('pip-mk-lock');
    var panel = layer.querySelector('.pip-mk-panel');
    if (window.pipFocus) window.pipFocus.off(panel);
    else if (st) trigger(st).focus();
    /* groep 16: geopend vanaf de sticky koopknop; daarna geldt het gewone veld weer als veld */
    if (st && st.viaSticky) { st.viaSticky = false; st.opener = null; st.modal = false; st.hint = ''; st.dropTo = null; }
    try { document.dispatchEvent(new CustomEvent('pip:mk-closed', { detail: { sid: st ? st.sid : null } })); } catch (e) {}
    setTimeout(function () {
      if (!layer.classList.contains('is-in')) {
        layer.hidden = true;
        layer.querySelector('.pip-mk-panel__body').innerHTML = '';
      }
    }, 260);
  }

  function closeEverything() {
    Object.keys(states).forEach(function (k) { if (states[k].open) markClosed(states[k]); });
    hideLayer();
  }

  /* ---------- kiezen ---------- */

  function choose(st, size) {
    var i = info(st, size, others(st));
    /* uitverkochte maat: alleen de popup, de maat wordt NIET gekozen (koopknop en gekozen maat blijven zoals ze waren);
       de aanmelding geldt wel voor precies deze maat in deze kleur */
    if (!i.a && i.v) {
      markClosed(st, true);
      openBis(st, size, i.v);
      return;
    }
    st.chosen = size;
    st.error = false;
    setDawn(st, size);
    renderTrigger(st);
    syncButtons(st);
    setTimeout(function () { syncButtons(st); }, 900);
    /* groep 16: laat de sticky koopknop weten dat er een maat is gekozen (die voegt dan eventueel meteen toe) */
    try { document.dispatchEvent(new CustomEvent('pip:mk-chosen', { detail: { sid: st.sid, size: size } })); } catch (e) {}
    closeList(st, true);
  }

  function openBis(st, size, v) {
    st.bis = { size: size, v: v };
    showLayer(st, 'bis');
  }

  function notify(st) {
    if (st.chosen != null) {
      var i = info(st, st.chosen, others(st));
      if (!i.a && i.v) { openBis(st, st.chosen, i.v); return; }
    }
    openList(st);
  }

  /* ---------- vanaf een productkaart (groep 13) ---------- */

  function cardTexts() {
    var el = document.getElementById('PipBisTexts');
    try { return (el && JSON.parse(el.textContent)) || {}; } catch (e) { return {}; }
  }

  /* btn: het envelopje met data-pip-bis = {"p": producttitel, "v": [[variant-id, maat], ...]} */
  function openCard(btn) {
    var d = null;
    try { d = JSON.parse(btn.getAttribute('data-pip-bis') || ''); } catch (e) { d = null; }
    if (!d || !d.v || !d.v.length) {
      var url = btn.getAttribute('data-url');
      if (url) window.location.href = url;
      return;
    }
    var sizes = [], variants = [];
    d.v.forEach(function (x) {
      var label = x[1] == null ? '' : String(x[1]);
      sizes.push(label);
      variants.push({ id: x[0], o: [label], a: false, q: 0 });
    });
    var st = {
      card: true, opener: btn, root: btn, d: { idx: 0, sizes: sizes, variants: variants, product: d.p || '', note: '', leftMax: 0 },
      t: cardTexts(), sid: 'pip-card', formId: null, chosen: null, error: false, open: false, bis: null
    };
    closeAllLists(null);
    if (variants.length === 1) { openBis(st, sizes[0], variants[0]); return; }
    st.open = true;
    showLayer(st, 'list');
  }

  /* ---------- aanmelden terug op voorraad (Klaviyo) ---------- */

  function companyId() {
    var s = document.querySelector('script[src*="klaviyo.js?company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : 'SmTEzn';
  }

  function submitBis(form) {
    var st = layerSt;
    if (!st || !st.bis || !st.bis.v) return;
    var t = st.t;
    var inp = form.querySelector('input[type="email"]');
    var err = form.querySelector('.pip-mk-bis__err');
    var fail = form.querySelector('.pip-mk-bis__fail');
    var btn = form.querySelector('.pip-mk-bis__btn');
    var email = String(inp.value || '').trim();
    var msg = '';
    if (!email) msg = t.required || 'Dit veld is verplicht';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) msg = t.invalid || 'Vul een geldig e-mailadres in';
    form.classList.toggle('is-invalid', !!msg);
    inp.setAttribute('aria-invalid', msg ? 'true' : 'false');
    err.textContent = msg;
    err.hidden = !msg;
    if (msg) { inp.focus(); return; }
    fail.hidden = true;
    btn.disabled = true;
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + st.bis.v.id } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      done(st);
    }).catch(function () {
      btn.disabled = false;
      fail.textContent = t.failed || 'Dat lukte niet. Probeer het nog een keer.';
      fail.hidden = false;
    });
  }

  function done(st) {
    if (!layer) return;
    var map = { maat: st.bis.size, product: st.d.product };
    layer.querySelector('.pip-mk-panel__title').textContent = st.t.doneTitle || '';
    layer.querySelector('.pip-mk-panel__body').innerHTML =
      '<p class="pip-mk__text pip-mk__text--done" role="status">' + esc(fill(noSize(st) ? (st.t.doneTextOne || st.t.doneText) : st.t.doneText, map)) + '</p>';
    var close = layer.querySelector('.pip-mk-panel__close');
    if (close) close.focus();
  }

  /* ---------- gebeurtenissen ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('[data-pip-bis-open]');
    if (card) {
      e.preventDefault();
      openCard(card);
      return;
    }
    var trig = t.closest('.pip-mk__trigger');
    if (trig) {
      var st = init(trig.closest('[data-pip-mk]'));
      if (!st) return;
      e.preventDefault();
      if (st.open) closeList(st, false);
      else openList(st);
      return;
    }
    var opt = t.closest('[data-pip-mk-size]');
    if (opt) {
      var r = opt.closest('[data-pip-mk]');
      var fr = !r && opt.closest('[data-pip-mk-for]'); /* groep 16: lijst in de sticky balk */
      var st2 = r ? init(r) : (fr ? init(rootFor(fr.getAttribute('data-pip-mk-for'))) : layerSt);
      if (st2) { e.preventDefault(); choose(st2, opt.getAttribute('data-pip-mk-size')); }
      return;
    }
    if (t.closest('[data-pip-mk-close]')) {
      e.preventDefault();
      hideLayer();
      return;
    }
    var nb = t.closest('[data-pip-mk-notify]');
    if (nb) {
      var st3 = init(rootFor(nb.getAttribute('data-pip-mk-notify')));
      if (st3) { e.preventDefault(); notify(st3); }
      return;
    }
    /* klik buiten de uitklaplijst (desktop) sluit hem; groep 16: de lijst in de sticky balk en de knop die hem opende tellen mee */
    Object.keys(states).forEach(function (k) {
      var s = states[k];
      if (!s.open || s.root.contains(t) || (layer && layer.contains(t))) return;
      if (s.dropTo && s.dropTo.contains(t)) return;
      if (s.opener && s.opener.contains && s.opener.contains(t)) return;
      closeList(s, false);
    });
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('pip-mk-bis')) return;
    e.preventDefault();
    submitBis(f);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (layer && !layer.hidden && layer.classList.contains('is-in')) { hideLayer(); return; }
      Object.keys(states).forEach(function (k) { if (states[k].open) closeList(states[k], true); });
      return;
    }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var a = document.activeElement;
    if (!a || !a.closest) return;
    if (a.classList.contains('pip-mk__trigger')) {
      var st = init(a.closest('[data-pip-mk]'));
      if (st && !st.open && e.key === 'ArrowDown') { e.preventDefault(); openList(st); }
      return;
    }
    var box = a.closest('.pip-mk__opts');
    if (!box) return;
    e.preventDefault();
    var all = [].slice.call(box.querySelectorAll('.pip-mk__opt'));
    var i = all.indexOf(a) + (e.key === 'ArrowDown' ? 1 : -1);
    if (all[Math.max(0, Math.min(all.length - 1, i))]) all[Math.max(0, Math.min(all.length - 1, i))].focus();
  });

  /* desktop: met Tab uit de lijst gaan sluit hem.
     27-09 (groep 11): Safari en Firefox op de Mac geven een knop bij een klik geen focus, maar zetten de focus op het
     dichtstbijzijnde vak met tabindex eromheen (bij Dawn is dat <main id="MainContent" tabindex="-1">). Daardoor sloot de
     lijst al bij het indrukken van de muis en kwam de klik op de maat nergens aan. Focus op een vak dat de maatkiezer
     omsluit telt daarom niet als "uit de lijst gaan". */
  document.addEventListener('focusin', function (e) {
    var tg = e.target;
    Object.keys(states).forEach(function (k) {
      var s = states[k];
      if (!s.open || MQ.matches || s.root.contains(tg)) return;
      if (tg && tg.contains && tg.contains(s.root)) return;
      if (layer && tg && layer.contains(tg)) return; /* groep 16: focus in de popup van de sticky knop */
      if (s.dropTo && tg && s.dropTo.contains(tg)) return; /* groep 16: focus in de lijst in de sticky balk */
      if (s.opener && tg && s.opener.contains && s.opener.contains(tg)) return; /* of op de knop die hem opende */
      markClosed(s);
    });
  });
  /* de focus niet laten verspringen bij het indrukken van de muis op een maat (zelfde oorzaak) */
  document.addEventListener('mousedown', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.pip-mk__drop [data-pip-mk-size], [data-pip-mk-for] [data-pip-mk-size]')) e.preventDefault();
  });

  /* een andere optie (bijvoorbeeld kleur) gekozen: voorraad per maat opnieuw bepalen */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var vs = t.closest('variant-selects');
    if (!vs || t.closest('.pip-size-opt')) return;
    var sid = String(vs.id || '').replace('variant-selects-', '');
    var st = states[sid] || init(rootFor(sid));
    if (!st) return;
    setTimeout(function () { renderTrigger(st); syncButtons(st); }, 30);
    setTimeout(function () { syncButtons(st); }, 900);
  });

  if (MQ.addEventListener) MQ.addEventListener('change', closeEverything);
  else if (MQ.addListener) MQ.addListener(closeEverything);

  window.pipMk = {
    init: init,
    /* groep 13: popup openen vanaf het envelopje op een productkaart */
    openCard: openCard,
    /* groep 16: vanaf de sticky koopknop de lijst openen (opts.drop = vak in de balk waarin de lijst op desktop uitrolt,
       opts.modal = popup op desktop, opts.opener = knop voor de focus, opts.hint = regel boven de maten,
       opts.notify = zoals de knop 'Houd me op de hoogte'). true = geopend */
    open: function (sid, opts) {
      var st = init(rootFor(sid));
      if (!st) return false;
      opts = opts || {};
      if (st.open && trigger(st) !== (opts.opener || null)) expanded(st, false);
      st.viaSticky = true;
      st.opener = opts.opener || null;
      st.modal = !!opts.modal;
      st.dropTo = (!MQ.matches && opts.drop) || null;
      st.hint = opts.hint || '';
      if (opts.notify) notify(st);
      else openList(st);
      return true;
    },
    /* groep 16: staat de lijst van de sticky koopknop open */
    isOpen: function (sid) {
      var st = init(rootFor(sid));
      return !!(st && st.open && st.viaSticky);
    },
    /* groep 16: de lijst sluiten zonder te kiezen */
    close: function (sid) {
      var st = init(rootFor(sid));
      if (st && st.open) closeList(st, false);
    },
    /* groep 16: de gekozen maat (null = nog geen maat gekozen) */
    chosen: function (sid) {
      var st = init(rootFor(sid));
      return st ? st.chosen : null;
    },
    /* aangeroepen door pip-maatkeuze bij de koopknop zonder maat; true = afgehandeld */
    error: function (sid) {
      var st = init(rootFor(sid));
      if (!st) return false;
      st.error = true;
      renderTrigger(st);
      /* fase 2, groep 10: de lijst niet meer openen, alleen de melding onder het veld in beeld brengen */
      var r = st.root.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight - 80) st.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
  };

  function initAll() {
    document.querySelectorAll('[data-pip-mk]').forEach(function (r) {
      var st = init(r);
      if (st) syncButtons(st);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
})();
